import api from '../../common/api';

const initialState = () => ({
  categoriesEducationMaterial: [
    {
      title: 'Работа с AI- экспертом',
      value: 'ai_expert'
    },
    {
      title: 'Работа с платформой',
      value: 'platform'
    },
    {
      title: 'Методология',
      value: 'methodology'
    },
    {
      title: 'Прочие',
      value: 'other'
    },
  ],
  allEducationMaterials: [],
  currentEducation: {},
  filters: {
    allEducationMaterials: {
      title: '',
      category: '',
      created_at: '',
      status: '',
      notes: '',
    }
  },
  pagination: {
    allEducationMaterials: {
      count: 0,
      page: 1,
      page_size: 10,
      total_page: 0,
      ordering: '',
    }
  },
  loading: {
    educationTable: false,
    creatingEducation: false,
  },
  stepCreatingEducation: null, // ['status_creating','status_editing','status_preview']
  requestResults: {
    create: {
      success: false
    },
    update: {
      success: false
    },
    delete: {
      success: false
    }
  },
  error: {
    createEducation: [],
    publishEducation: [],
    deleteEducation: [],
  },
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async fetchAllEducation({ commit, getters }) {
      try {
        commit('SET_LOADING', true);
        const params = getters.queryParams('allEducationMaterials');
        const response = await api.get('/training-materials/', {
          params
        });
        if (response && response?.length > 0) {
          commit('SET_ALL_EDUCATIONS', response);
        } else {
          commit('SET_ALL_EDUCATIONS', []);
        }
        return response;
      } catch (err) {
        return err;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async fetchDetailEducation({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.get(`/training-materials/${payload.id}/`);
        if (response && response.id) {
          commit('SET_CURRENT_EDUCATION', response);
          return { success: true, data: response };
        }
      } catch (err) {
        return { success: false, err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async createEducation({ commit }, payload) {
      try {
        commit('SET_LOADING', { field: 'createEducation', value: true });
        const response = await api.post('/training-materials/', payload.data);
        commit('SET_RESULTS_CREATING', { success: true, data: response });
        return { success: true, data: response };
      } catch (err) {
        commit('SET_ERROR_CREATING', err);
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', { field: 'createEducation', value: false });
      }
    },
    async partialUpdateEducation({ commit }, payload) {
      try {
        commit('SET_LOADING', { field: 'createEducation', value: true });
        const response = await api.patch(`/training-materials/${payload.id}/`, payload.data);
        commit('SET_RESULTS_UPDATING', { success: true, data: response });
        return { success: true, data: response };
      } catch (err) {
        commit('SET_ERROR_CREATING', err);
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', { field: 'createEducation', value: false });
      }
    },
    async publishEducation({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post(`/training-materials/${payload.id}/publish/`);
        return { success: true, data: response };
      } catch (err) {
        commit('SET_ERROR_PUBLISH', err);
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async unPublishEducation({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post(`/training-materials/${payload.id}/unpublish/`);
        return { success: true, data: response };
      } catch (err) {
        commit('SET_ERROR_PUBLISH', err);
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async deleteEducation({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.delete(`/training-materials/${payload.id}/`);
        commit('SET_RESULTS_DELETING', { success: true, data: response });
        return { success: true, data: response };
      } catch (err) {
        commit('SET_ERROR_DELETE', err);
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },

  },
  mutations: {
    SET_ALL_EDUCATIONS(state, materials) {
      state.allEducationMaterials = materials;
    },
    SET_CURRENT_EDUCATION(state, material) {
      state.currentEducation = material;
    },
    SET_STEP_CREATING(state, status) {
      state.stepCreatingEducation = status;
    },
    SET_ERROR_CREATING(state, error) {
      state.error.createEducation.push(error.data);
    },
    SET_ERROR_PUBLISH(state, error) {
      state.error.publishEducation = error;
    },
    SET_ERROR_DELETE(state, error) {
      state.error.deleteEducation = error;
    },
    CLEAR_ERROR(state) {
      state.error.publishEducation = [];
      state.error.createEducation = [];
    },
    SET_RESULTS_CREATING(state, result) {
      state.requestResults.create = result;
    },
    SET_RESULTS_UPDATING(state, result) {
      state.requestResults.update = result;
    },
    SET_RESULTS_DELETING(state, result) {
      state.requestResults.delete = result;
    },
    CLEAR_RESULTS(state) {
      state.requestResults.create = { success: false };
      state.requestResults.delete = { success: false };
      state.requestResults.update = { success: false };
    },
    CLEAR_CURRENT_EDUCATION(state) {
      state.currentEducation = {};
    },
    SET_LOADING(state, loading) {
      state.loading[loading.field] = loading.value;
    }

  },
  getters: {
    allMaterials: (state) => state.allEducationMaterials,
    pagination: (state) => (field) => state.pagination[field],
    queryParams: (state) => (field) => {
      const params = { ...state.filters[field], ...state.pagination[field] };
      Object.keys(params).forEach(key => {
        const hiddenField = ['count', 'total_page', 'next', 'previous', 'totalPage'];
        if (params[key] === null || params[key] === '' || params[key] === undefined || hiddenField.includes(key)) {
          delete params[key];
        }
      });
      return params;
    },
    getAllEducationCategories: (state) => state.categoriesEducationMaterial,
    getError: (state) => state.error,
    getResults: (state) => state.requestResults,
    getCurrentEducation: (state) => state.currentEducation,
    getCurrentStepCreating: (state) => state.stepCreatingEducation,
    isCreatingEducation: (state) => state.stepCreatingEducation === 'status_creating',
    isEditingEducation: (state) => state.stepCreatingEducation === 'status_editing',
    isPreviewEducation: (state) => state.stepCreatingEducation === 'status_preview',
    educationBlocks: (state) => {
      const categoryMap = new Map(
        state.categoriesEducationMaterial.map(category => [
          category.value,
          { ...category, educations: [] }
        ])
      );
      state.allEducationMaterials.forEach(education => {
        const block = categoryMap.get(education.category);
        if (block && education.status === 'published') {
          block.educations.push(education);
        }
      });
      return Array.from(categoryMap.values());
    },
    educationBlocksIsEmpty: (state) => !state.allEducationMaterials
      .some((education) => education.status === 'published')
  },
};
